// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2IXOZ","image":"Header_image__3PS2i","name":"Header_name__T1Zs4","info":"Header_info__lnQTm","infoRow":"Header_infoRow__3nN1y"};